import React from "react";
import {
  Box,
  Button,
  Paper,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { Add, ChevronRight, ManageAccounts, PictureAsPdf } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { createClubRedirectPath } from "../../utils/createClub";

const CLUB_MANAGEMENT_GUIDE_URL =
  "https://s3.eu-west-2.amazonaws.com/easyagility.co.uk/club-management-admin-guide.pdf";

const CreateClubPrompt: React.FC = () => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, sm: 2.5 },
        mb: 3,
        borderRadius: 2,
        border: "1px solid",
        borderColor: "#00395A30",
        bgcolor: "#00395A08",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        gap: { xs: 2, sm: 2.5 },
      }}
    >
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: 2,
          bgcolor: "#00395A",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          "& .MuiSvgIcon-root": { fontSize: 26, color: "white" },
        }}
      >
        <ManageAccounts />
      </Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 700, color: "#00395A", mb: 0.5 }}
        >
          Set up your agility club
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
          Try club administration in sandbox mode — manage members, training
          groups, and invoicing for free (up to 5 members). Emails stay with
          you as admin until you go live.
        </Typography>
      </Box>

      <Stack direction={{ xs: "column", sm: "row" }} spacing={1} sx={{ flexShrink: 0 }}>
        <Button
          component={RouterLink}
          to={createClubRedirectPath()}
          variant="contained"
          startIcon={<Add />}
          endIcon={<ChevronRight />}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            borderRadius: 2,
            px: 2.5,
            py: 1.25,
            bgcolor: "#00395A",
            whiteSpace: { xs: "normal", sm: "nowrap" },
            "&:hover": { bgcolor: theme.palette.primary.dark },
          }}
        >
          Create your club
        </Button>
        <Button
          variant="outlined"
          startIcon={<PictureAsPdf />}
          component="a"
          href={CLUB_MANAGEMENT_GUIDE_URL}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            textTransform: "none",
            fontWeight: 600,
            borderRadius: 2,
            px: 2.5,
            py: 1.25,
            borderColor: "#00395A40",
            color: "#00395A",
            whiteSpace: { xs: "normal", sm: "nowrap" },
            "&:hover": { borderColor: "#00395A", bgcolor: "#00395A08" },
          }}
        >
          Club Management guide
        </Button>
      </Stack>
    </Paper>
  );
};

export default CreateClubPrompt;
